import { Box, Typography } from "@mui/material";
import { RobotLoader } from "@qubit/autoparts";
import { skipToken } from "@reduxjs/toolkit/query";
import { t } from "i18next";
import { useSearchParams } from "react-router-dom";

import { useAppSelector } from "~/app/store";

import { selectThisWorkstation } from "~/redux/selectors/workstationsSelectors";
import { useEmptyBinReportQuery } from "~/redux/warehouse/autostoreGrid.hooks";

const Loader = <RobotLoader sx={{ placeSelf: "center" }} />;

export const BinReport = () => {
  const [queryParams] = useSearchParams();
  const sourceBinConfigurationId = queryParams.get("sourceBinConfigurationId");
  const targetBinConfigurationId = queryParams.get("targetBinConfigurationId");

  const workstation = useAppSelector(selectThisWorkstation);

  const { data: emptyBinReport, isLoading: emptyBinReportLoading } =
    useEmptyBinReportQuery(workstation?.autostoreGridId ?? skipToken);

  const sourceBinConfigurationReport = emptyBinReport?.find(
    (r) => r.binConfigurationId === sourceBinConfigurationId
  );
  const targetBinConfigurationReport = emptyBinReport?.find(
    (r) => r.binConfigurationId === targetBinConfigurationId
  );

  return (
    <>
      {emptyBinReportLoading ? (
        Loader
      ) : (
        <Box
          aria-label="source-bin-report"
          sx={{
            placeSelf: "center",
            textAlign: "right",
            color: "darkGray.main",
            mt: "-48px"
          }}
        >
          <Typography variant="body1">
            {t(
              `autostoreBin.empty ${sourceBinConfigurationReport?.numberOfCompartments as 1 | 2 | 4} compartments`
            )}
          </Typography>
          <Typography variant="stat">
            {sourceBinConfigurationReport?.binsWithNoInventory}
          </Typography>
        </Box>
      )}
      <Box />
      {emptyBinReportLoading ? (
        Loader
      ) : (
        <Box
          aria-label="target-bin-report"
          sx={{
            placeSelf: "center",
            textAlign: "right",
            color: "darkGray.main"
          }}
        >
          <Typography variant="body1">
            {t(
              `autostoreBin.empty ${targetBinConfigurationReport?.numberOfCompartments as 1 | 2 | 4} compartments`
            )}
          </Typography>
          <Typography variant="stat">
            {targetBinConfigurationReport?.binsWithNoInventory}
          </Typography>
        </Box>
      )}
      <Box />
    </>
  );
};
